<template>
  <!--Absence modal -->
  <b-modal
    :id="modalID"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    size="xl"
    :title="modalTitle"
  >
    <template #default>
      <alert-error
        v-if="form.errors.get('message')"
        :form="form"
        :message="form.errors.get('message')"
      ></alert-error>
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <div class="row d-flex align-items-center">
          <div class="col-md-8">
            <div class="form-group">
              <label for="employe"
                >Employé absent <span class="text-danger">*</span>
              </label>
              <v-custom-select
                label="nom"
                id="employe"
                :options="equipe"
                :reduce="(employe) => employe.uuid"
                v-model="form.employe"
                placeholder="Employé"
                required
                :disabled="edit"
              >
                <template v-slot:option="{ nom }">
                  <h5 style="margin: 0">{{ nom }}</h5>
                </template>
                <template #no-options> Aucune données </template>
                <template #search="{ attributes, events }">
                  <input
                    class="custom-select-height vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-custom-select>
              <input
                type="hidden"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('employe'),
                }"
              />
              <has-error :form="form" field="employe"></has-error>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="type_absence"
                >Type absence <span class="text-danger">*</span></label
              >
              <v-custom-select
                label="nom"
                id="type_absence"
                :options="type_absences"
                :reduce="(type_absence) => type_absence.uuid"
                v-model="form.type_absence"
                placeholder="Type absence"
                required
              >
                <template v-slot:option="{ nom }">
                  <h5 style="margin: 0">{{ nom }}</h5>
                </template>
                <template #no-options> Aucune données </template>
                <template #search="{ attributes, events }">
                  <input
                    class="custom-select-height vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-custom-select>
              <input
                type="hidden"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('type_absence'),
                }"
              />
              <has-error :form="form" field="type_absence"></has-error>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="remplacant">Remplaçant </label>
              <v-custom-select
                label="nom"
                id="remplacant"
                :options="employes"
                :reduce="(remplacant) => remplacant.uuid"
                v-model="form.remplacant"
                placeholder="Remplaçant"
              >
                <template v-slot:option="{ nom }">
                  <h5 style="margin: 0">{{ nom }}</h5>
                </template>
                <template #no-options> Aucune données </template>
                <template #search="{ attributes, events }">
                  <input
                    class="custom-select-height vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-custom-select>
              <input
                type="hidden"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('remplacant'),
                }"
              />
              <has-error :form="form" field="remplacant"></has-error>
            </div>
          </div>

          <div class="col-md-12 mt-n1">
            <div class="form-group">
              <label for="commentaire"
                >Commentaire (max : 100 caractères )
              </label>
              <textarea
                id="commentaire"
                v-model="form.commentaire"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('commentaire'),
                }"
                rows="5"
                maxlength="100"
              ></textarea>
              <has-error :form="form" field="commentaire"></has-error>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template #modal-footer>
      <button type="button" class="btn btn-danger mr-2" @click="closeModal()">
        Fermer
      </button>

      <button
        type="submit"
        class="btn btn-custom-primary w-40"
        @click.prevent="submit"
        style="min-width: 100px"
      >
        {{ !edit ? 'Créer' : 'Enregistrer' }}
      </button>
    </template>
  </b-modal>
</template>

<script>
// import DatePicker from 'vue2-datepicker';

export default {
  props: {
    propForm: {
      type: Object,
      required: true,
    },
    modalID: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    equipe: {
      type: Array,
      default() {
        return [];
      },
    },
    employes: {
      type: Array,
      default() {
        return [];
      },
    },
    type_absences: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      form: null,
    };
  },
  components: {
    // DatePicker,
  },

  methods: {
    /**
     * Modal note
     */

    closeModal() {
      this.$emit('closeModal');
      this.$bvModal.hide(this.modalID);
    },

    init() {
      this.form = this.propForm;
    },
    submit() {
      this.$emit('submit', this.form);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
